// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".problem-edit {\n  height: 100%;\n  position: relative;\n}\n.problem-edit .v-stepper, .problem-edit .v-stepper__items, .problem-edit .v-stepper__content, .problem-edit .v-stepper__wrapper {\n  height: 100%;\n}\n.problem-edit .v-stepper__items {\n  padding-bottom: 144px;\n}", ""]);
// Exports
module.exports = exports;
